<template>
  <div class="clients-reviews">
    <div class="flex-top-box">
      <div class="title-box">{{ $t('clientsReviews.customerReviews') }}</div>
      <router-link to="/reviewsView" class="decore-under"
        >{{ $t('clientsReviews.allRatings') }}</router-link
      >
    </div>
    <div class="box-body" v-if="rates?.length">
      <div v-if="!loader">

        <div class="opinion-box" v-for="review in rates" :key="review.id">
          <img :src="review.user_image" class="reviewImg" alt="" />
          <div>
            <div class="reviewer-name mb-1">{{ review.user_name }}</div>
            <div class="flex-sm-gap mb-1">
              <div class="time-rev font14 gray-col">
                <i class="fa-regular fa-clock"></i> {{ review.created_at }}
              </div>
              <div class="rate-main">
                <star-rating
                  :show-rating="false"
                  :rtl="true"
                  v-model:rating="review.rate"
                  :star-size="16"
                  :read-only="true"
                  :rounded-corners="true"
                  :increment="0.5"
                  active-color="#ffb60c"
                ></star-rating>
              </div>
            </div>
            <p class="gray-col font14">
              {{ review.comment }}
            </p>
          </div>
        </div>
      </div>
      <div v-else class="mt-4">
        <Skeleton width="100%" height="70px" class="mb-3"></Skeleton>
        <Skeleton width="100%" height="70px" class="mb-3"></Skeleton>
      </div>
    </div>
    <p v-else class="font15 gray-col mt-4 text-center">{{ $t('clientsReviews.noRatings') }}</p>
  </div>
</template>

<script setup>
// imports
import { onMounted, defineProps } from "vue";
import StarRating from "vue-star-rating";
import Skeleton from "primevue/skeleton";


//props
const props = defineProps(["rates", "loader"]);

// functions


// lifecycle hooks
onMounted(() => {
  console.log(props);
  // getReviews();
});
</script>
